document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".resource-list__item");

  if (!items.length) return;

  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target); // 1回だけでOKなら
      }
    });
  }, { threshold: 0.15 });

  items.forEach((el) => io.observe(el));
});